import {
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { ControlPoint, LockOpenSharp, LockSharp } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import PrintIcon from "@material-ui/icons/Print";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import TableComponent from "app/common/Component/Table/TableComponent";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import IconMedicalHistory from "app/common/Icon/EyeTestTabs/IconMedicalHistory";
import IconDelete from "app/common/Icon/IconDelete";
import IconPen from "app/common/Icon/IconPen";
import { ACTIVE_STATUS, LOCKED_STATUS } from "app/common/LocalConst";
import {
  checkPaymentMethodLimits,
  formatMoney,
  formatNumber,
  getDateTime,
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleHisReadOnly,
  isRoleManualExchange,
  isRoleTechician,
  isSalesConsultant,
} from "app/common/LocalFunction";
import { lockTreatment } from "app/services/TreatmentPlanCardService";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import PaymentVoucherPopup from "../../FeeTab/Popup/PaymentVoucherPopup";
const ListRegisterTreatmentPlan = () => {
  const { t } = useTranslation();

  const {
    handleOpenCreateOrEditTreatmentPlanPopup,
    handleChangeFormSearchTreatmentPlan,
    pageRegisterTreatmentPlan,
    searchRegisterTreatmentPlan,
    handleOpenConfirmDelete,
    setSelectedRowTreatmentPlan,
    handleOpenPopupTreatmentPlan,
    handleOpenChangeTreatmentPlanPopup,
    handleOpenConfirmUnlock,
    handleOpenConfirmlock,
    handleOpenHistoryTreatmentPopup,
    getTreatmentTimesOfServices,
    pagingRegisterTreatmentPlan,
  } = useStore().patientManagementStore.registerTreatmentPlanStore;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isReadonly = isRoleHisReadOnly();
  const isRoleCashierPermission = isRoleCashier();
  const isRoleBranchManagerPermission = isRoleBranchManager();
  const isSalesConsultantPermission = isSalesConsultant();
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isDoctors = isDoctor();
  const isAccountant = isRoleHisAccountant();
  const admin = isAdmin();
  const isManualExchange = isRoleManualExchange();
  const canManualExchange = admin || isManualExchange;

  const hasAddPermission =
    isAdmins ||
    isRoleCashierPermission ||
    isAccountant ||
    isRoleBranchManagerPermission;

  const {
    initialPatient,
    customerSourceWalkIn,
    handleGetPatientOverviewByIdNotLoading,
    handleOpenHistoryStaffRevenuePopup,
  } = useStore().patientManagementStore.patientGeneralStore;

  const {
    listPos,
    listHomecredit,
    listPos_tragop,
    openPaymentVoucherPopup,
    initialPaymentVoucher,
    createPaymentVoucherWithListMethod,
    handleClosePaymentVoucherPopup,
    listStk,
    getListPaymentMethod,
    listPaymentMethod,
    handleOpenPaymentVoucherPopup,
  } = useStore().feeStore.serviceFeeTabStore;
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuOpen = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowData);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };
  const defaultDepartment = useDefaultDepartment();
  return (
    <Grid
      container
      spacing={1}
      className="justify-center cards-body pt-0 mt-2"
      style={{
        zIndex: 1,
        position: "relative",
      }}
    >
      <Grid item xs={12}>
        <TableComponent
          showOrdinalNumbers
          titleNodata={t("noData")}
          data={pageRegisterTreatmentPlan?.content || []}
          minWidth={"720px"}
          maxHeight={"460px"}
          name="ListRegisterTreament"
          showMoreButton
          columns={[
            {
              title: t("Tạo phiếu chi"),
              field: "action",
              width: "70px",
              render: (row) => {
                const isLocked = row?.activeStatus === LOCKED_STATUS;
                return (
                  <div className="flex-center gap-2">
                    {hasAddPermission && (
                      <>
                        <Tooltip title={"Tạo phiếu chi"}>
                          <div
                            onClick={() => {
                              let staffRevenues = row?.staffRevenues?.map(
                                (el) => ({ ...el, id: null })
                              );
                              handleOpenPaymentVoucherPopup(
                                initialPatient?.patientInfo,
                                null,
                                customerSourceWalkIn,
                                {
                                  treatmentPlanCard: row,
                                  totalAmount: row?.totalBillPatientPaid || 0,
                                  staffRevenues: staffRevenues,
                                }
                              );
                            }}
                            className="mr-1 flex"
                          >
                            <ControlPoint
                              style={{
                                color: "#3f51b5",
                                fontSize: "22px",
                              }}
                            />
                          </div>
                        </Tooltip>
                      </>
                    )}
                  </div>
                );
              },
            },
            hasAddPermission && {
              title: t("action"),
              field: "action",
              align: "center",
              width: "70px",
              render: (row) => {
                const svLocked =
                  row?.paServiceRegister?.find(
                    (el) => el?.activeStatus === LOCKED_STATUS
                  ) ||
                  row?.drugs?.find((el) => el?.activeStatus === LOCKED_STATUS);
                const isLocked = row?.cardStatus === 2;

                return (
                  <>
                    <div className="flex-center gap-2 cursor">
                      <Tooltip>
                        <div
                          onClick={() =>
                            handleOpenCreateOrEditTreatmentPlanPopup(row)
                          }
                        >
                          <IconPen />
                        </div>
                      </Tooltip>
                      {canManualExchange && (
                        <Tooltip
                          title={
                            isLocked
                              ? "Liệu trình đã bị khóa - không thể đổi liệu trình"
                              : svLocked
                              ? `${svLocked?.name} đã bị khóa nên không thể đổi liệu trình`
                              : "Đổi liệu trình"
                          }
                        >
                          <div
                            onClick={() => {
                              if (!isLocked && !svLocked) {
                                handleOpenChangeTreatmentPlanPopup(
                                  row,
                                  initialPatient?.patientInfo
                                );
                              }
                            }}
                            style={{
                              cursor:
                                isLocked || svLocked
                                  ? "not-allowed"
                                  : "pointer",
                              opacity: isLocked || svLocked ? 0.5 : 1,
                            }}
                          >
                            <SyncAltIcon color="primary" />
                          </div>
                        </Tooltip>
                      )}
                      <Tooltip
                        title={
                          isLocked
                            ? "Liệu trình đã bị khóa - không thể xóa liệu trình"
                            : "Xóa liệu trình"
                        }
                      >
                        <div
                          className="flex"
                          onClick={
                            row?.cardStatus !== 2
                              ? () => handleOpenConfirmDelete(row?.id)
                              : undefined
                          }
                          style={{
                            cursor: isLocked ? "not-allowed" : "pointer",
                            opacity: isLocked ? 0.5 : 1,
                          }}
                        >
                          <IconDelete />
                        </div>
                      </Tooltip>

                      <Tooltip title="Tùy chọn">
                        <IconButton
                          size="small"
                          onClick={(e) => handleMenuOpen(e, row)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                    <Menu
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl) && selectedRow?.id === row?.id}
                      onClose={handleMenuClose}
                      PaperProps={{
                        style: {
                          boxShadow: "none",
                        },
                      }}
                    >
                      {!isLocked && (
                        <MenuItem>
                          {!isLocked && (
                            <Tooltip title={"Khóa"}>
                              <div
                                onClick={() => {
                                  handleOpenConfirmlock(row?.id);
                                  handleMenuClose();
                                }}
                                className="mr-1"
                                style={{ display: "flex" }}
                              >
                                <LockSharp
                                  style={{
                                    color: "#3f51b5",
                                    fontSize: 22,
                                    marginRight: 8,
                                  }}
                                />
                                <span>Khóa</span>
                              </div>
                            </Tooltip>
                          )}
                        </MenuItem>
                      )}
                      {isLocked && (
                        <MenuItem>
                          <Tooltip title={"Mở khóa"}>
                            <div
                              onClick={() => {
                                handleOpenConfirmUnlock(row?.id);
                                handleMenuClose();
                              }}
                              className="mr-1 "
                              style={{ display: "flex" }}
                            >
                              <LockOpenSharp
                                style={{
                                  color: "#3f51b5",
                                  fontSize: 22,
                                  marginRight: 8,
                                }}
                              />
                              <span>Mở khóa</span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}
                      {/* <MenuItem >
                          <Tooltip>
                            <div
                              onClick={() => {handleOpenCreateOrEditTreatmentPlanPopup(row); handleMenuClose()}}
                              style={{display:"flex" }}
                            >
                              <IconPen style={{ fontSize: 20, marginRight: 8 }} />
                              <span>Chỉnh sửa</span>
                            </div>
                          </Tooltip>
                      </MenuItem>
                      <MenuItem>
                        <Tooltip
                            title={
                              isLocked
                                ? "Liệu trình đã bị khóa - không thể đổi liệu trình"
                                : "Đổi liệu trình"
                            }
                          >
                            <div
                              onClick={
                                row?.cardStatus !== 2
                                  ? () => handleOpenChangeTreatmentPlanPopup(row)
                                  : undefined
                              }
                              style={{
                                cursor: isLocked ? "not-allowed" : "pointer",
                                opacity: isLocked ? 0.5 : 1,
                                display:"flex"
                              }}
                            >
                              <SyncAltIcon style={{ color: "#3f51b5", fontSize: 22, marginRight: 8 }} />
                              <span>Đổi liệu trình</span>
                            </div>
                        </Tooltip>
                      </MenuItem>
                      <MenuItem>
                        <Tooltip
                          title={
                            isLocked
                              ? "Liệu trình đã bị khóa - không thể xóa liệu trình"
                              : "Xóa liệu trình"
                          }
                        >
                          <div
                            className="flex"
                            onClick={
                              row?.cardStatus !== 2
                                ? () => handleOpenConfirmDelete(row?.id)
                                : undefined
                            }
                            style={{
                              cursor: isLocked ? "not-allowed" : "pointer",
                              opacity: isLocked ? 0.5 : 1,
                              display:"flex"
                            }}
                            
                          >
                            <IconDelete style={{ color: "red", fontSize: 22, marginRight: 8 }} />
                            <span>Xóa liệu trình</span>
                          </div>
                        </Tooltip>
                      </MenuItem> */}
                      {!isMobile && (
                        <MenuItem>
                          <Tooltip
                            title="In phiếu"
                            onClick={() => {
                              setSelectedRowTreatmentPlan([row]);
                              handleOpenPopupTreatmentPlan(true);
                              handleMenuClose();
                            }}
                          >
                            <div style={{ display: "flex" }}>
                              <PrintIcon
                                style={{ fontSize: 22, marginRight: 8 }}
                              />
                              <span>In phiếu</span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}

                      <MenuItem>
                        <Tooltip
                          title="Xem lịch sử liệu trình"
                          onClick={() => {
                            setSelectedRowTreatmentPlan([row]);
                            handleMenuClose();
                            handleOpenHistoryTreatmentPopup({
                              id: row?.id,
                            });
                          }}
                        >
                          <div className="flex gap-1 align-center">
                            <IconMedicalHistory
                              style={{ width: "18px", marginRight: 8 }}
                              color="blue"
                            />
                            <span>Xem lịch sử liệu trình</span>
                          </div>
                        </Tooltip>
                      </MenuItem>

                      <MenuItem>
                        <Tooltip
                          title="Xem lịch sử phân bổ"
                          onClick={() => {
                            setSelectedRowTreatmentPlan([row]);
                            handleMenuClose();
                            handleOpenHistoryStaffRevenuePopup({
                              // id:row?.id,
                              treatmentPlanCardId: row?.id,
                            });
                          }}
                        >
                          <div className="flex gap-1 align-center">
                            <IconMedicalHistory
                              style={{ width: "18px", marginRight: 8 }}
                              color="blue"
                            />
                            <span>Xem lịch sử phân bổ</span>
                          </div>
                        </Tooltip>
                      </MenuItem>
                    </Menu>
                  </>
                );
              },
            },
            {
              title: t("Mã đơn hàng"),
              field: "code",
              fitContent: true,
            },
            {
              title: t("Tên liệu trình"),
              field: "treatmentPlanName",
              width: "450px",
              render: (row) => {
                const displayServices = row?.paServiceRegister || [];
                const displayMedicalSupply = row?.medicalSupplyOrders || [];
                const displayDrugs = row?.drugs || [];
                let itemIndex = 1;
                return (
                  <>
                    <div className="flex mt-2" style={{ fontSize: "13px" }}>
                      <div>
                        Đã thu:{" "}
                        <b style={{ color: "green" }}>
                          {formatMoney(row?.totalBillPatientPaid || 0)}
                        </b>
                      </div>
                      <span className="mx-1">|</span>
                      <div>
                        Cần thu:{" "}
                        <b style={{ color: "red" }}>
                          {formatMoney(row?.amountActuallyPaid)}
                        </b>
                      </div>
                    </div>
                    <span className="clientCard-name">
                      {checkPaymentMethodLimits()
                        ? row?.clientCard?.registeredName ||
                          row?.clientCard?.name
                        : row?.clientCard?.name}
                    </span>
                    {(displayServices || []).map(
                      (serviceItem, serviceIndex) => (
                        <div
                          key={`service-${serviceIndex}`}
                          className="flex items-start mb-2"
                          style={{
                            fontSize: "14px",
                            flexDirection: "column",
                            borderBottom: "1px solid gray",
                          }}
                        >
                          <div
                            className="flex items-center flex-wrap service-info-line"
                            style={{
                              width: "100%",
                              gap: "4px",
                            }}
                          >
                            {itemIndex++}.
                            <span
                              className="text-ellipsis"
                              style={{
                                maxWidth: "200px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                color: "sienna",
                              }}
                            >
                              {checkPaymentMethodLimits()
                                ? serviceItem?.service?.registeredName ||
                                  serviceItem?.service?.name ||
                                  "Tên dịch vụ khai báo"
                                : serviceItem?.service?.tradeName ||
                                  serviceItem?.service?.name ||
                                  "Tên dịch vụ"}
                            </span>
                            <CloseIcon fontSize="inherit" />
                            <span className="value-medical">
                              {serviceItem?.quantity || 1}
                            </span>
                            <span className=" text-gray-400">|</span>
                            <div>
                              Điều trị:{" "}
                              <b>{serviceItem?.totalPerformedTimes || 0}</b>
                              {!serviceItem?.unLimited && (
                                <>
                                  <span>|</span>
                                  <b style={{ color: "red" }}>
                                    {serviceItem?.totalTreatmentTimes || 0}
                                  </b>
                                </>
                              )}
                            </div>
                            {serviceItem?.unLimited && (
                              <>
                                <span>|</span>
                                <Tooltip title="Không giới hạn">
                                  <span className="unlimited-badge">♾️</span>
                                </Tooltip>
                              </>
                            )}
                            {serviceItem?.expiryDate && (
                              <>
                                <span className="text-gray-400">|</span>
                                <span style={{ color: "#666" }}>
                                  <b>HSD:</b>{" "}
                                  {getDateTime(serviceItem?.expiryDate)}
                                </span>
                              </>
                            )}
                          </div>

                          <div
                            className="flex"
                            style={{
                              fontSize: "13px",
                              color: "#333",
                              width: "100%",
                              marginTop: 4,
                            }}
                          >
                            <Tooltip title="Đã thu">
                              <div>
                                <b style={{ color: "green" }}>
                                  {formatMoney(
                                    serviceItem?.totalBillPatientPaid || 0
                                  )}
                                </b>
                              </div>
                            </Tooltip>

                            <span className="mx-1">|</span>
                            <Tooltip title="Cần thu">
                              <div>
                                <b style={{ color: "red" }}>
                                  {formatMoney(serviceItem?.amountActuallyPaid)}
                                </b>
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      )
                    )}

                    {(displayDrugs || []).map((serviceItem, serviceIndex) => (
                      <div
                        key={`drug-${serviceIndex}`}
                        className="flex items-center mb-1"
                        style={{
                          flexDirection: "column",
                          borderBottom: "1px solid gray",
                        }}
                      >
                        <div
                          className="flex items-center flex-wrap"
                          style={{
                            width: "100%",
                            gap: "4px",
                            flexWrap: "wrap",
                          }}
                        >
                          {itemIndex++}.
                          <span
                            style={{
                              maxWidth: "200px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              display: "inline-block",
                              verticalAlign: "middle",
                              fontSize: "13px",
                              color: "sienna",
                            }}
                            title={serviceItem?.drug?.name || "Tên sản phẩm "}
                          >
                            {checkPaymentMethodLimits()
                              ? serviceItem?.drug?.registeredName ||
                                serviceItem?.drug?.name ||
                                "Tên sản phẩm khai báo"
                              : serviceItem?.drug?.name || "Tên sản phẩm"}
                          </span>
                          <CloseIcon fontSize="inherit" />
                          <span className="value-medical">
                            {serviceItem?.soldQuantity || 1}
                          </span>
                          {serviceItem?.unLimited && (
                            <span className="unlimited-badge">
                              ♾️ Không giới hạn
                            </span>
                          )}
                          {serviceItem?.expiryDate && (
                            <>
                              <span className="mx-1 text-gray-400">|</span>
                              <span style={{ color: "#666" }}>
                                <b>HSD:</b>{" "}
                                {getDateTime(serviceItem?.expiryDate)}
                              </span>
                            </>
                          )}
                        </div>
                        <div
                          className="flex"
                          style={{
                            fontSize: "13px",
                            color: "#333",
                            width: "100%",
                            marginTop: 4,
                          }}
                        >
                          <Tooltip title="Đã thu">
                            <div>
                              <b style={{ color: "green" }}>
                                {formatMoney(
                                  serviceItem?.totalBillPatientPaid || 0
                                )}
                              </b>
                            </div>
                          </Tooltip>

                          <span className="mx-1">|</span>
                          <Tooltip title="Cần thu">
                            <div>
                              <b style={{ color: "red" }}>
                                {formatMoney(serviceItem?.amountActuallyPaid)}
                              </b>
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    ))}

                    {(displayMedicalSupply || []).map(
                      (serviceItem, serviceIndex) => (
                        <div
                          className="flex items-center mb-1"
                          style={{ fontSize: "13px" }}
                        >
                          <div
                            className="flex items-center"
                            style={{ borderBottom: "1px solid gray" }}
                          >
                            {itemIndex++}.
                            <span
                              style={{
                                maxWidth: "200px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                verticalAlign: "middle",
                              }}
                              title={
                                serviceItem?.medicalSupply?.name || "Tên vật tư"
                              }
                            >
                              {serviceItem?.medicalSupply?.name || "Tên vật tư"}
                            </span>
                            <CloseIcon fontSize="inherit" />
                            <span className="value-medical">
                              {serviceItem?.soldQuantity || 1}
                            </span>
                            {serviceItem?.unLimited && (
                              <span className="unlimited-badge">
                                ♾️ Không giới hạn
                              </span>
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </>
                );
              },
            },
            {
              title: t("Giá"),
              field: "price",
              render: (row) => formatMoney(row?.price),
            },
            // {
            //   title: t("Số lượng"),
            //   field: "quantity",
            // },
            {
              title: t("Thành tiền"),
              field: "price",
              width: "200px",
              render: (row) => (
                <>
                  <div className="total-data-group">
                    <div className="flex justify-between">
                      Tổng tiền:{" "}
                      <b>{formatMoney(row?.price * row?.quantity)}</b>
                    </div>
                    <div className="flex justify-between">
                      Giảm giá: <b>{formatMoney(row?.discount)}</b>
                    </div>
                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Số tiền (sau giảm):{" "}
                        <b>
                          {formatMoney(
                            row?.price * row?.quantity - (+row?.discount || 0)
                          )}
                        </b>
                      </b>
                    </div>
                    <div className="flex justify-between">
                      Vat: <b>{formatMoney(+row?.taxTotal)}</b>
                    </div>
                    <div
                      style={{
                        background: "#ccc",
                        width: "100%",
                        height: "1px",
                        margin: "4px 0",
                      }}
                    ></div>
                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Tổng thanh toán:{" "}
                        <b>{formatMoney(+row?.amountActuallyPaid || 0)}</b>
                      </b>
                    </div>
                    {row?.allocateDiscount ? (
                      <div>
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Giảm tổng HĐ:{" "}
                          <b>{formatMoney(row?.allocateDiscount)}</b>
                        </b>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ),
            },
            {
              title: t("Ngày đăng ký"),
              field: "startDate",
              render: (row) => getDateTime(row?.startDate),
            },
            {
              title: t("Cơ sở"),
              field: "department?.name",
              render: (row) => row?.department?.name,
            },
            {
              title: t("Doanh thu phân bổ(nhân viên)"),
              field: "staffRevenue",
              // width: "550px",
              render: (val) => (
                <>
                  {val?.staffRevenues?.map((staffRevenue, index) => (
                    <div
                      key={index}
                      className="revenue-item"
                      style={{
                        display: "flex",
                        fontSize: isMobile ? 12 : 14,
                        marginBottom: 6,
                        padding: "4px 0",
                        borderBottom: "1px solid gray",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <span className="revenue-percent">
                          {staffRevenue?.source?.name} -{" "}
                        </span>
                        <span className="position">
                          {" "}
                          {staffRevenue?.position?.name} -{" "}
                        </span>
                      </div>
                      <div>
                        <b className="staff-name">
                          {staffRevenue?.staff?.staffName}
                        </b>
                        <i className="revenue-percent">
                          {staffRevenue?.actualAmount && (
                            <span className="label-primary-number">
                              {formatMoney(staffRevenue?.actualAmount)}
                              {"-"}
                            </span>
                          )}
                          {formatNumber(staffRevenue?.percentRevenue) + "%"}
                        </i>
                      </div>
                    </div>
                  ))}
                </>
              ),
            },
            {
              field: "note",
              title: t("Ghi chú"),
              render: (val) => (
                <div
                  style={{
                    width: isMobile ? "auto" : "300px",
                    minWidth: isMobile ? "auto" : "300px",
                    maxWidth: isMobile ? "auto" : "300px",
                    maxHeight: "5em",
                    // overflowY: "auto",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    paddingRight: "4px",
                    lineHeight: "1.6em",
                  }}
                >
                  <i>{val?.note}</i>
                </div>
              ),
            },
            {
              title: t("Cho phép chỉnh sửa"),
              field: "isEditable",
              align: "center",
              render: (row) => (row?.clientCard?.isEditable ? "✓" : ""),
            },
            {
              title: t("Trạng thái"),
              field: "cardStatus",
              render: (row) => (
                <div>
                  {row?.cardStatus === ACTIVE_STATUS ? (
                    <Tooltip title="Đang mở">
                      <LockOpenIcon />
                    </Tooltip>
                  ) : row?.cardStatus === LOCKED_STATUS ? (
                    <Tooltip title="Đã khóa">
                      <LockIcon />
                    </Tooltip>
                  ) : (
                    ""
                  )}
                  {row?.cancelAmount != null && (
                    <div className="service-name " style={{ fontSize: "10px" }}>
                      {" "}
                      Số tiền chốt khi hủy:{formatMoney(row?.cancelAmount)}
                    </div>
                  )}
                </div>
              ),
            },
            {
              field: "createdBy",
              title: t("Người tạo"),
            },
            {
              field: "modifiedBy",
              title: t("Người sửa"),
            },
            {
              field: "createDate",
              title: t("Ngày tạo hệ thống"),
              render: (val) => getDateTime(val?.createDate),
            },
            {
              title: t("Ngày hết hạn sử dụng"),
              field: "endDate",
              render: (row) => getDateTime(row?.endDate),
            },
            {
              title: t("Mã đơn hàng cũ"),
              field: "codeOld",
              fitContent: true,
              render: (val) => (
                <span style={{ whiteSpace: "nowrap" }}>
                  {val?.oldTreatmentPlanCard?.code ||
                    val?.oldDrugOrder?.code ||
                    val?.oldService?.code}
                </span>
              ),
            },
          ].filter(Boolean)}
          dataPagination={{
            pageIndex: searchRegisterTreatmentPlan?.pageIndex,
            pageSize: searchRegisterTreatmentPlan?.pageSize,
            totalElements: pageRegisterTreatmentPlan?.totalElements,
            totalPages: pageRegisterTreatmentPlan?.totalPages,
            setPageIndex: (pageIndex) =>
              handleChangeFormSearchTreatmentPlan({ pageIndex }),
            setPageSize: (pageSize) =>
              handleChangeFormSearchTreatmentPlan({ pageSize }),
          }}
        />
        {openPaymentVoucherPopup && (
          <PaymentVoucherPopup
            open={openPaymentVoucherPopup}
            handleClose={handleClosePaymentVoucherPopup}
            initialPaymentVoucher={initialPaymentVoucher}
            handleSubmit={async (values, setSubmitting) => {
              console.log("🚀 ~ ListRegisterTreatmentPlan ~ values:", values);
              const data = await createPaymentVoucherWithListMethod(
                {
                  ...values,
                  notPaging: true,
                },
                setSubmitting
              );
              if (data?.responseStatus !== false) {
                const treatmentId = values?.treatmentPlanCard?.id;
                if (treatmentId) {
                  const treatmentInList =
                    pageRegisterTreatmentPlan?.content?.find(
                      (item) => item?.id === treatmentId
                    );
                  if (treatmentInList?.cardStatus !== LOCKED_STATUS) {
                    await lockTreatment(treatmentId);
                  }
                }
                await handleGetPatientOverviewByIdNotLoading(patientId);
                await pagingRegisterTreatmentPlan();
              }
            }}
            patient={initialPatient?.patientInfo}
            listPaymentMethod={listPaymentMethod}
            listStk={listStk}
            listPos={listPos}
            listHomecredit={listHomecredit}
            listPos_tragop={listPos_tragop}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default memo(observer(ListRegisterTreatmentPlan));
